import { useAuth } from '@neotech-solutions-org/neofusion-fe-shared';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { useUserData } from '../queries';
import { useMarketplaceConfig } from '../queries/marketplace';
import { FEATURE_FLAG } from '../constants/featureFlags';

const isProductFlagEnabled = (flag?: boolean) => flag !== false;

const useProductAvailability = () => {
  const { isAuthenticated } = useAuth();
  const promotionsEnabled = useFeatureIsOn(FEATURE_FLAG.PROMOTIONS_ENABLED);
  const { data: userData, isCasinoOnlyClient, isSportsbookOnlyClient, isSuccess: isUserDataSuccess } = useUserData();
  const {
    data: marketplaceData,
    isError: isMarketplaceConfigError,
    isSuccess: isMarketplaceConfigSuccess,
  } = useMarketplaceConfig();

  if (!promotionsEnabled) {
    const isCasinoOnlyProduct = isAuthenticated && isCasinoOnlyClient;
    const isSportsbookOnlyProduct = isAuthenticated && isSportsbookOnlyClient;

    return {
      isCasinoOnlyProduct,
      isSportsbookOnlyProduct,
      hasSportsbookAccess: !isCasinoOnlyProduct,
      hasCasinoAccess: !isSportsbookOnlyProduct,
      isProductAvailabilityResolved: !isAuthenticated || isUserDataSuccess,
    };
  }

  const marketplaceProducts = marketplaceData?.marketplaceConfig.products;
  const userProducts = userData?.products;

  const isSportsbookEnabledByMarketplace = isProductFlagEnabled(marketplaceProducts?.sportsbook);
  const isCasinoEnabledByMarketplace = isProductFlagEnabled(marketplaceProducts?.casino);
  const isSportsbookEnabledByUser =
    !isAuthenticated || !isUserDataSuccess || isProductFlagEnabled(userProducts?.sportsbook);
  const isCasinoEnabledByUser = !isAuthenticated || !isUserDataSuccess || isProductFlagEnabled(userProducts?.casino);

  const hasSportsbookAccess = isSportsbookEnabledByMarketplace && isSportsbookEnabledByUser;
  const hasCasinoAccess = isCasinoEnabledByMarketplace && isCasinoEnabledByUser;
  const isMarketplaceAvailabilityResolved = Boolean(isMarketplaceConfigSuccess || isMarketplaceConfigError);
  const isProductAvailabilityResolved = isMarketplaceAvailabilityResolved && (!isAuthenticated || isUserDataSuccess);

  return {
    isCasinoOnlyProduct: hasCasinoAccess && !hasSportsbookAccess,
    isSportsbookOnlyProduct: hasSportsbookAccess && !hasCasinoAccess,
    hasSportsbookAccess,
    hasCasinoAccess,
    isProductAvailabilityResolved,
  };
};

export default useProductAvailability;
